import { render, staticRenderFns } from "./RejectedByPharmacy.vue?vue&type=template&id=8a19b5d0"
import script from "./RejectedByPharmacy.vue?vue&type=script&lang=js"
export * from "./RejectedByPharmacy.vue?vue&type=script&lang=js"
import style0 from "./RejectedByPharmacy.vue?vue&type=style&index=0&id=8a19b5d0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports